import Label from '@mindtickle/label';
import { MenuActionLoader } from './Loader';

import { TEXT_COLORS, TEXT_MODIFIERS, TEXT_TYPES } from '@mindtickle/styles/lib/classNames';

import useSwitchDomainData from './hooks/useSwitchDomainData';
import { StyledDropdownActionItemWrapper } from './style';
import { MixpanelEventNameType, MixpanelTrackType } from '~/components/GlobalHeader/Admin/type';
import messages from '../../messages';
import { DomainInfo } from '~/components/GlobalHeader/Shared/type';

type SwitchDomainProps = {
  defer: () => boolean;
  onHideDropdownContent: Function;
  track: MixpanelTrackType<MixpanelEventNameType>;
  eventName: MixpanelEventNameType;
  domain: DomainInfo;
  className?: string;
  menuKey: string;
};

const SwitchDomain = ({
  defer,
  onHideDropdownContent,
  track,
  eventName,
  domain,
  className,
  menuKey,
}: SwitchDomainProps) => {
  const { isRemoteInitialized, handleSwitchDomainClick } = useSwitchDomainData({
    defer,
    onHideDropdownContent,
    track,
    eventName,
    menuKey,
    domain,
  });

  return (
    <StyledDropdownActionItemWrapper
      onClick={handleSwitchDomainClick}
      data-testid={'switch-ls-btn'}
      className={className}
    >
      {!isRemoteInitialized ? (
        <MenuActionLoader />
      ) : (
        <Label
          tag="div"
          type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
          color={TEXT_COLORS.TERTIARY}
          message={messages[menuKey as keyof typeof messages]}
          className="dropdown-action-label"
          modifier={TEXT_MODIFIERS.TYPOGRAPHY_MOD_STRONG}
        />
      )}
    </StyledDropdownActionItemWrapper>
  );
};

export default SwitchDomain;
